$(window).load(function() {
  if ($('.yotpo-review-badge').length > 0) {
    var reviewUrl = $('.yotpo-review-badge').attr('href');
    $('.yotpo-review-badge').find('a.text-m').attr('href', reviewUrl).addClass('yotpo-review-badge');
  }
});

$(function() {
  $(".waiting-list").modaal({
    fullscreen : false,
    custom_class : 'waiting-list-modal',
    width: 600
  });
});


$(function() {
  	var form = $('form.form-mc');
    if ( form.length > 0 ) {
        $('form.form-mc .newsletter__submit').on('click', function ( event ) {
            if ( event ) event.preventDefault();
            form = $(this).parents("form.form-mc");
            if ($('#fc-email').val() == '') {
               alert('Email cannot be empty');
            } else {
                register(form);
            }
        });
    }

    function register(form) {
        $.ajax({
            type : form.attr('method'),
            url : form.attr('action'),
            data : form.serialize(),
            cache : false,
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            beforeSend: function() {
                form.find('button[type="submit"]').text('Submitting..');
            },
            success : function(data) {
                form.find('button[type="submit"]').text('Submit');
                alert('success');
              	$('#modaal-close').trigger('click');
            },
            error : function(err) {
              	form.find('button[type="submit"]').text('Submit');
                alert("Could not connect to the registration server. Please try again later.");
              	$('#modaal-close').trigger('click');
            }
        });
    }
});


// Cache selectors
var lastId,
    stickyMenu = $("#nav__sticky"),
    stickyMenuHeight = stickyMenu.outerHeight()+15,
    // All list items
    menuItems = stickyMenu.find("a"),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function(){
      var item = $($(this).attr("href"));
      if (item.length) { return item; }
    });

/*
// Bind click handler to menu items
// so we can get a fancy scroll animation
menuItems.click(function(e){
  var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top-stickyMenuHeight+1;
  $('html, body').stop().animate({ 
      scrollTop: offsetTop
  }, 300);
  e.preventDefault();
});
*/

// Bind to scroll
$(window).scroll(function(){
   // Get container scroll position
   var fromTop = $(this).scrollTop()+stickyMenuHeight;
   
   // Get id of current scroll item
   var cur = scrollItems.map(function(){
     if ($(this).offset().top < fromTop)
       return this;
   });
   // Get the id of the current element
   cur = cur[cur.length-1];
   var id = cur && cur.length ? cur[0].id : "";
   
   if (lastId !== id) {
       lastId = id;
       // Set/remove active class
       menuItems
         .parent().removeClass("active")
         .end().filter("[href='#"+id+"']").parent().addClass("active");
    /* $("#nav__sticky").scrollCenter(".nav__item", 300); */
   }                   
});

/*
$("#nav__sticky a").on("click", function() {
  $("#nav__sticky a").removeClass("active");
  $(this).addClass("active");
  // CALL scrollCenter PLUSGIN
  $("#nav__sticky").scrollCenter(".active", 300);
});

jQuery.fn.scrollCenter = function(elem, speed) {

  // this = #timepicker
  // elem = .active

  var active = jQuery(this).find(elem); // find the active element
  //var activeWidth = active.width(); // get active width
  var activeWidth = active.width() / 2; // get active width center

  //alert(activeWidth)

  //var pos = jQuery('#timepicker .active').position().left; //get left position of active li
  // var pos = jQuery(elem).position().left; //get left position of active li
  //var pos = jQuery(this).find(elem).position().left; //get left position of active li
  var pos = active.position().left + activeWidth; //get left position of active li + center position
  var elpos = jQuery(this).scrollLeft(); // get current scroll position
  var elW = jQuery(this).width(); //get div width
  //var divwidth = jQuery(elem).width(); //get div width
  pos = pos + elpos - elW / 4; // for center position if you want adjust then change this

  jQuery(this).animate({
    scrollLeft: pos
  }, speed == undefined ? 1000 : speed);
  return this;
};

jQuery.fn.scrollCenterORI = function(elem, speed) {
  jQuery(this).animate({
    scrollLeft: jQuery(this).scrollLeft() - jQuery(this).offset().left + jQuery(elem).offset().left
  }, speed == undefined ? 1000 : speed);
  return this;
};
*/
function hideFixedCart() {
  var fixedcart = document.getElementById("fixed-cart-form");
  var navsticky = document.getElementById("nav__sticky");
  if (fixedcart.style.display === "none") {
    fixedcart.style.display = "block";
    navsticky.style.display = "block";
  } else {
    fixedcart.style.display = "none";
    navsticky.style.display = "none";
  }
}

/*================ TESTIMONIAL MODAL ================*/

if ($('body').hasClass('template-product')) {

  var reviewSlider = $('#testimonial-carousel');
  var instaSlider = $('#instagram-carousel');
  var reviewBtnNext = $('#rev-next').find('button');
  var reviewBtnPrev = $('#rev-prev').find('button');
  var instaBtnNext = $('#insta-next').find('button');
  var instaBtnPrev = $('#insta-prev').find('button');

  var groupCells = 2;
  var adaptiveHeight = false;

  if ($(window).width() <= 640) {
    groupCells = true;
    adaptiveHeight = true;
  }

  var sliderOptions = {
    draggable: false,
    wrapAround: true,
    cellAlign: 'left',
    contain: true,
    imagesLoaded: true,
    prevNextButtons: false,
    pageDots: false,
    //   groupCells: 1,
  };

  reviewSlider.flickity({
    draggable: false,
    wrapAround: true,
    cellAlign: 'left',
    contain: true,
    imagesLoaded: true,
    prevNextButtons: false,
    pageDots: false,
    //   groupCells: groupCells,
    adaptiveHeight: adaptiveHeight
  });
  instaSlider.flickity(sliderOptions);

  var reviewFlickity = reviewSlider.data('flickity');
  var instaFlickity = instaSlider.data('flickity');

  reviewSlider.on('select.flickity', function() {
    if (!reviewFlickity.slides[reviewFlickity.selectedIndex - 1]) {
      reviewBtnPrev.attr('disabled', 'disabled');
      reviewBtnNext.removeAttr('disabled');
    } else if (!reviewFlickity.slides[reviewFlickity.selectedIndex + 1]) {
      reviewBtnNext.attr('disabled', 'disabled');
      reviewBtnPrev.removeAttr('disabled');
    } else {
      reviewBtnPrev.removeAttr('disabled');
      reviewBtnNext.removeAttr('disabled');
    }
  });

  instaSlider.on('select.flickity', function() {
    if (!instaFlickity.slides[instaFlickity.selectedIndex - 1]) {
      instaBtnPrev.attr('disabled', 'disabled');
      instaBtnNext.removeAttr('disabled');
    } else if (!instaFlickity.slides[instaFlickity.selectedIndex + 1]) {
      instaBtnNext.attr('disabled', 'disabled');
      instaBtnPrev.removeAttr('disabled');
    } else {
      instaBtnPrev.removeAttr('disabled');
      instaBtnNext.removeAttr('disabled');
    }
  });

  reviewBtnNext.on("click", function() {
    reviewSlider.flickity("next", true);
  });

  reviewBtnPrev.on("click", function() {
    reviewSlider.flickity("previous", true);
  });

  instaBtnNext.on("click", function() {
    instaSlider.flickity("next", true);
  });

  instaBtnPrev.on("click", function() {
    instaSlider.flickity("previous", true);
  });

  var modal = document.getElementById("review-modal");
  var load_reviews = document.getElementById("init-testimonial-modal");
  var init_load_reviews = document.getElementById("init-load-more-reviews");
  var span = document.getElementsByClassName("close")[0];
  var review_content = $("#review-content");
  var show_more_reviews = document.getElementById("show-more-reviews");
  var load_more_reviews_wrapper = $(".show-more-wrapper");
  var load_more_counter = 0;
  var reviewsLength = 0;

  init_load_reviews.onclick = function(event) {
    event.preventDefault();
    if (!jQuery.isEmptyObject(customer_testimonials)) 
      displayReviews(customer_testimonials, load_more_counter);
    modal.style.display = "block";
  }

  load_reviews.onclick = function(event) {
    event.preventDefault();
    if (!jQuery.isEmptyObject(customer_testimonials)) 
      displayReviews(customer_testimonials, load_more_counter);
    modal.style.display = "block";
  }

  show_more_reviews.onclick = function(event) {
    displayReviews(customer_testimonials, load_more_counter);
  }

  span.onclick = function() {
    hideModal();
  }

  window.onclick = function(event) {
    if (event.target == modal) {
      hideModal();
    }
  }

  function hideModal() {
    modal.style.display = "none";
    load_more_reviews_wrapper.show();
    load_more_counter = 0;
    review_content.empty();
  }

  function displayReviews(reviews, counter) {
    var reviewObject = reviews["index_" + counter];
    for ( var i = 1; i <= 9; i++) {
      var html = `<div class="carousel-cell">
<div class="testimonial">
<div class="testimonial-img-wrapper">
<img class="testimonial-img" src="${reviewObject['testimonial_image_' + i]}" />
</div>
<div class="testimonial-content-wrapper">
<h2 class="testimonial-name">${reviewObject['testimonial_name_' + i]}</h6>
<img class="testimonial-review" src="${reviewObject['testimonial_review_' + i]}" />
<h2 class="testimonial-location">${reviewObject['testimonial_location_' + i]}</h2>
<p class="testimonial-quote">${reviewObject['testimonial_quote_' + i]}</p>
</div>
</div>
</div>`;
      if (reviewObject['testimonial_image_' + i]) {
        review_content.append(html);
      }
    }

    load_more_counter++;

    if (Object.keys(customer_testimonials).length == load_more_counter) {
      load_more_reviews_wrapper.hide();
    }
  }

}